import React, { useState, useEffect } from 'react';
import 'bootstrap';
import './Styles/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import RootLayout from './Layout';
import PageSeoComponent from './SEO';
import RoutesComponents from './Routes';
import SEO from './Constant/SEO.json';

const helmetContext = {};

function App() {
  const [showPopup, setShowPopup] = useState(false);

  // useEffect(() => {
  //   const showTimer = setTimeout(() => {
  //     setShowPopup(true);

  //     const hideTimer = setTimeout(() => {
  //       setShowPopup(false);
  //     }, 3000); // Hide popup after 3 seconds

  //     return () => clearTimeout(hideTimer);
  //   }, 5000); // Show popup after 5 seconds

  //   return () => clearTimeout(showTimer); // Cleanup timer on unmount
  // }, []);

  return (
    <BrowserRouter>
      <HelmetProvider context={helmetContext}>
        <RootLayout>
          <PageSeoComponent {...SEO.default} />
          <RoutesComponents />

      

        </RootLayout>
      </HelmetProvider>
    </BrowserRouter>
  );
}

export default App;
